import React, {useContext} from 'react';
import {useParams} from "react-router-dom";
import LinkCell3 from "../../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import CheckboxCell from "../../../../components/Pages/TablePage/Table/Cells/CheckboxCell";
import OrganizationHistoryTemplate from "../../../../components/Templates/OrganizationHistoryTemplate";
import {SystemManager_API} from "../../SystemManager.API";
import UploadLists from "../../../../components/Pages/TablePage/Table/Cells/UploadLists/UploadLists";
import EmailSendCell3 from "../../../../components/Pages/TablePage/Table/Cells/EmailSendCell3";
import TextCell from "../../../../components/Pages/TablePage/Table/Cells/NewCells/TextCell/TextCell";
import {AuthContext} from "../../../../context/AuthContext";

function OrgHistoryMedcenter(props) {
    const {medId, medName, orgId, orgName, verCenterId} = useParams()

    const {token} = useContext(AuthContext)

    const url = `/api/v2/systemManagers/${token.userId}/verificationCenters/${verCenterId}/medCenters/${medId}/organizations/${orgId}/histories?`

    const {
        changePayedStatus,
        uploadListsVerCenter,
        pdfGenerationVerCenter,
        addNewStudyVerCenter
    } = SystemManager_API.counterAgents.verificationCenter


    const breadCrumbsItems = [
        {title: 'Контрагенты'},
        {title: 'Мед. центры', link: process.env.REACT_APP_URL_PREFIX + '/counterAgents/medCenters'},
        {title: medName, link: process.env.REACT_APP_URL_PREFIX + `/counterAgents/medCenters/${medId}/${medName}/${verCenterId}/organizations`},
        {title: orgName, actual: true},
    ]
    const {REACT_APP_URL_PREFIX} = process.env

    const linkToPatients = props => {
        const url = REACT_APP_URL_PREFIX + `/counterAgents/medCenters/${medId}/${medName}/${verCenterId}/organizations/${orgId}/${orgName}/history/${props.idArr[0]}/${props.cellContent['name']}/patients`
        return <LinkCell3 linkRoute={url} linkTitle={props.cellContent['name']}
                          editClick={_ => props.cellData.onClick(orgId)}/>
    }

    const pdfGenerationCell = props => {

        return <EmailSendCell3 method={pdfGenerationVerCenter().method}
                               api={pdfGenerationVerCenter( props.idArr[0]).api}/>
    }

    const uploadCell = (props) => {
        const verCenterId = props.idArr[1]
        const historyId = props.idArr[0]
        return <UploadLists uploaded={props.cellContent.uploaded}
                            api={uploadListsVerCenter(token.userId,verCenterId, medId, orgId, historyId).api}/>
    }


    const accessResultCell = (props) => {
        const historyId = props.idArr[0]
        const verCenterId = props.idArr[1]
        return <CheckboxCell payed={props.cellContent} updateUrl={changePayedStatus(token.userId,verCenterId, medId, orgId, historyId).api}/>
    }

    return (
        <OrganizationHistoryTemplate
            getOrgHistoryAPI={url}
            addNewStudyConfig={{show: true, API: addNewStudyVerCenter(token.userId,verCenterId, medId, orgId).api}}
            breadCrumbsItems={breadCrumbsItems}
            tableModel={
                {

                    firstRow: [
                        {title: 'Название', id: 'name'},
                        {title: 'Загрузить списки', id: ''},
                        {title: 'Дата', id: 'resultDate'},
                        {title: 'Количество людей', id: ''}, // Сортировка не добавлена
                        {title: '', id: 'base'},
                        {title: 'Вызов', id: ''},            // Сортировка не добавлена
                        {title: 'Доступ к результату', id: ''},
                        {title: 'Печать', id: ''},
                    ],
                    haveToShow: [
                        {
                            id: 'organization_info',
                            idArr: ['id'],
                            type: 'wrapperCell',
                            typeData: {cell: linkToPatients}
                        },
                        {
                            id: 'document',
                            type: 'wrapperCell',
                            idArr: ['id', 'verification_id'],
                            typeData: {cell: uploadCell}
                        },
                        {
                            id: 'date',
                            type: 'wrapperCell',
                            typeData: {
                                cell: props => <TextCell
                                    text={props.cellContent}/>
                            }
                        },
                        {id: 'patients_count'},
                        {id: 'base'},
                        {id: 'invite_count'},
                        {
                            id: 'payed',
                            idArr: ['id', 'verification_id'],
                            type: 'wrapperCell',
                            typeData: {cell: accessResultCell}
                        },
                        {
                            id: 'id',
                            type: 'wrapperCell',
                            idArr: ['id', "verification_id"],
                            typeData: {cell: pdfGenerationCell}
                        },
                    ]
                }
            }
        />
    );
}

export default OrgHistoryMedcenter;

